import React from "react";

const formatPhoneNumber = (number) => {
  if (!number) return null;
  const cleanedNumber = number.replace(/\D/g, "");

  const areaCode = cleanedNumber.slice(0, 3);
  const firstPart = cleanedNumber.slice(3, 6);
  const secondPart = cleanedNumber.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};
const ContactPanelForEditPopup = ({
  panel_name,
  name,
  address1,
  address2,
  city,
  state,
  zip_code,
  phone_number,
  fax_number,
  ext = "",
  email,
  websiteURL,
  is_website = true,
  is_email = true,
  pageName = "",
  onSelectObject,
  className = "",
  dynamic_label,
  handleShowBlockHelp,
  panelStyle = {},
  isMedicalTreatment = false,
}) => {
  return (
    <>
      <div
        className={`info-div ${className}`}
        style={{
          width: pageName !== "" && pageName?.startsWith("litigation") ? "255px" : "260px",
        }}
      >
        <div
          className=""
          style={{
            cursor: "pointer",
          }}
        >
          <div onClick={onSelectObject}>
            <p
              className="bg-primary-5 columnsTitle text-center text-primary font-weight-semibold text-uppercase align-items-center justify-content-center position-relative"
              style={{
                height: "25px",
                whiteSpace: "nowrap",
                display: "flex",
                ...panelStyle,
              }}
            >
              {panel_name}
              {pageName === "litigation" && (
                <span
                  className="panel_help"
                  style={{
                    width: "25px",
                    height: "25px",
                    position: "absolute",
                    top: "0",
                    right: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (handleShowBlockHelp) {
                      handleShowBlockHelp();
                    }
                  }}
                >
                  ?
                </span>
              )}
            </p>
            {name?.trim() ? (
              <p
                style={{ backgroundColor: "var(--primary-2)" }}
                className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5 text-truncated"
              >
                {name}
              </p>
            ) : (
              <p
                className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5"
                style={{
                  backgroundColor: "var(--primary-2)",
                  color: "var(--primary-25)",
                }}
              >
                {dynamic_label?.trim() ? dynamic_label : "Full Name"}
              </p>
            )}
            <div>
              <p
                className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                style={{
                  backgroundColor: "var(--primary-4)",
                }}
              >
                {address1 || address2 ? (
                  <p className="font-weight-semibold ">
                    {address1 && <span>{address1}</span>}
                    {address1 && address2 && <span>, </span>}{" "}
                    {/* Render comma only if both addresses exist */}
                    {address2 && <span>{address2}</span>}
                  </p>
                ) : (
                  <span
                    className="font-weight-semibold text-capitalize"
                    style={{
                      backgroundColor: "var(--primary-4)",
                      color: "var(--primary-25)",
                    }}
                  >
                    Address
                  </span>
                )}
              </p>

              <p
                className="inline-row-h-21 text-capitalize bg-speciality-2 p-r-5 p-l-5"
                style={{
                  backgroundColor: "var(--primary-2)",
                }}
              >
                {city ? (
                  <span className="font-weight-semibold">{city},</span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    city,
                  </span>
                )}{" "}
                {state ? (
                  <span className="font-weight-semibold">{state}</span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    state
                  </span>
                )}{" "}
                {zip_code ? (
                  <span className="font-weight-semibold">{zip_code}</span>
                ) : (
                  <span
                    className="font-weight-semibold "
                    style={{
                      color: "var(--primary-25)",
                      textTransform: "uppercase",
                    }}
                  >
                    zip
                  </span>
                )}
              </p>
            </div>
            <div>
              <p
                className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                style={{
                  backgroundColor: "var(--primary-4)",
                }}
              >
                {phone_number ? (
                  <span className="font-weight-semibold">{formatPhoneNumber(phone_number)}</span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    (###) ###-####
                  </span>
                )}
                {ext && (
                  <>
                    <small
                      className="ms-1 font-weight-semibold"
                      style={{ color: "var(--primary-25)" }}
                    >
                      ext
                    </small>{" "}
                    <span className="font-weight-semibold">{ext}</span>
                  </>
                )}
              </p>
            </div>
            <div>
              <p
                className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                style={{
                  backgroundColor: "var(--primary-4)",
                }}
              >
                {!isMedicalTreatment && (
                  <>
                    {fax_number ? (
                      <div
                        className="d-flex align-items-center"
                        style={{
                          gap: "5px",
                        }}
                      >
                        <span className="font-weight-semibold">
                          {formatPhoneNumber(fax_number)}
                        </span>
                        <small
                          className=""
                          style={{
                            color: "var(--primary-25)",
                            fontWeight: "600",
                            fontSize: "12px",
                          }}
                        >
                          fax
                        </small>{" "}
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        style={{
                          gap: "5px",
                        }}
                      >
                        <span
                          className="font-weight-semibold"
                          style={{ color: "var(--primary-25)" }}
                        >
                          (###) ###-####
                        </span>
                        <small
                          className=""
                          style={{
                            color: "var(--primary-25)",
                            fontWeight: "600",
                            fontSize: "12px",
                          }}
                        >
                          fax
                        </small>{" "}
                      </div>
                    )}
                  </>
                )}
              </p>
            </div>
            {is_email && (
              <div>
                <p
                  className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                  style={{
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  {!isMedicalTreatment && (
                    <>
                      {email ? (
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "240px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "black",
                          }}
                          className="font-weight-semibold"
                        >
                          {email}
                        </span>
                      ) : (
                        <span
                          className="font-weight-semibold"
                          style={{ color: "var(--primary-25)" }}
                        >
                          email@provider.com
                        </span>
                      )}
                    </>
                  )}
                </p>
              </div>
            )}
          </div>

          {is_website && (
            <div>
              <p
                className="inline-row-h-21 p-r-5 text-center p-l-5 bg-speciality-2"
                style={{ backgroundColor: "var(--primary-2)", height: "21px" }}
              >
                {websiteURL ? (
                  <a
                    href={websiteURL.startsWith("https") ? websiteURL : `https://${websiteURL}`}
                    target="_blank"
                    className="font-weight-semibold"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",

                      maxWidth: "240px",
                    }}
                  >
                    {websiteURL}
                  </a>
                ) : (
                  <a className="" style={{ color: "var(--primary-25)", fontWeight: "600" }}>
                    www.websiteurl.com
                  </a>
                )}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(ContactPanelForEditPopup);
